import { render, staticRenderFns } from "./bundling-cart-item.vue?vue&type=template&id=5e8372ff&scoped=true"
import script from "./bundling-cart-item.vue?vue&type=script&lang=js"
export * from "./bundling-cart-item.vue?vue&type=script&lang=js"
import style0 from "./bundling-cart-item.vue?vue&type=style&index=0&id=5e8372ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8372ff",
  null
  
)

export default component.exports